(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('CouponSearch', CouponSearch);

    CouponSearch.$inject = ['$resource'];

    function CouponSearch($resource) {
        var resourceUrl =  'api/_search/coupons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
